"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _UploadExcel = _interopRequireDefault(require("@/components/UploadExcel"));
var _log = require("@/utils/log");
var _survey = require("@/api/survey");
var _cookie = require("@/utils/cookie");
var _index = _interopRequireDefault(require("../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LearningPassportIndex',
  components: {
    UploadExcelComponent: _UploadExcel.default,
    SearchBox: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data() {
    return {
      // search
      query: {
        page: 1,
        limit: 50,
        q: undefined
      },
      // table
      tableLoading: false,
      surveyList: [],
      total: 0,
      // dialog
      dialogVisible: false,
      fullscreenloading: false,
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop'
    };
  },
  created() {
    this.getList();
  },
  methods: {
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'name') {
        order === 'ascending' ? this.query.sort = '+name' : this.query.sort = '-name';
      }
      if (prop === 'email') {
        order === 'ascending' ? this.query.sort = '+email' : this.query.sort = '-email';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = '+createdAt' : this.query.sort = '-createdAt';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      this.search(1);
    },
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('LP survey query', this.query);
      (0, _survey.getLPSurvey)(token, this.query).then(response => {
        (0, _log.showDebugLog)('LP survey-Search-response', response);
        this.surveyList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('LP survey-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    // dialog methods
    handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    handleSuccess({
      results,
      header
    }) {
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        const rawDataQuestions = [];
        header.forEach(h => {
          const include = ['#', 'Let\'s start with your name.', 'What is your LifeHikes user ID?'];
          if (/\[(.*?)\]/g.test(h) || include.includes(h)) {
            rawDataQuestions.push(h);
          }
        });
        const rawData = rawDataQuestions.map(h => {
          const answer = r[h];
          const match = /\[(.*?)\]/g.exec(h.trim());
          let categoryTypeTag = ['', '', ''];
          if (match !== null) {
            categoryTypeTag = match[1].split('-');
            if (categoryTypeTag.length < 3) {
              for (let i = categoryTypeTag.length, l = 3; i < l; i++) {
                categoryTypeTag.push('');
              }
            }
          }
          return {
            question: h.trim(),
            answer: answer.toString().trim(),
            category: categoryTypeTag[0].trim().toLowerCase(),
            type: categoryTypeTag[1].trim().toLowerCase(),
            tag: categoryTypeTag[2].trim().toLowerCase()
          };
        });
        return {
          hikeId: _lodash.default.trim(r['#']),
          email: _lodash.default.trim(_lodash.default.toLower(r['What is your LifeHikes user ID?'])),
          name: _lodash.default.trim(r['Let\'s start with your name.']),
          rawData,
          startDate: _lodash.default.trim(r['Start Date (UTC)']),
          submitDate: _lodash.default.trim(r['Submit Date (UTC)']),
          networkId: _lodash.default.trim(r['Network ID'])
        };
      });
      this.tableHeader = header;
    },
    EmailFormatErrorStyle(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== '' ? 'error' : '';
    },
    doUpload() {
      if (this.tableData.length <= 0) {
        const msg = this.$i18n.t('otrTraining.msgEmptyRecord');
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.saveLPSurvey();
    },
    saveLPSurvey() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.isShowResult = true;
      this.tableData.forEach((d, i) => {
        const data = {
          typeformId: d.hikeId,
          email: d.email,
          name: d.name,
          rawData: d.rawData,
          startDate: d.startDate,
          submitDate: d.submitDate,
          networkId: d.networkId
        };
        (0, _survey.saveLPSurvey)(token, data).then(response => {
          (0, _log.showDebugLog)('saveLPSurvey-API-OK', response.data);
          this.tableData[i].result = 'Success';
          this.$set(this.tableData, i, this.tableData[i]);
          this.noOfSuccess += 1;
          (0, _log.showDebugLog)('Table content row', i);
          this.fullscreenloading = false;
          this.getList();
        }).catch(error => {
          // showDebugLog('saveLPSurvey-API-Fail', error.response)
          const msg = typeof error.response === 'undefined' ? error.toString() : error.response.data.message;
          this.tableData[i].result = 'Fail:' + msg;
          this.$set(this.tableData, i, this.tableData[i]);
          this.noOfFail += 1;
          // showDebugLog('saveLPSurvey-API-Fail', msg)
          (0, _log.showDebugLog)('Table content row', i);
          this.fullscreenloading = false;
        });
      });
    }
  }
};